/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import cookie from 'react-cookies'

import { Typography, DatePicker, Space, Divider } from 'antd'
import { HeaderMenuWrapper, RightMenuBox, LeftMenuBox, ContentWrapper } from './style'

import SmortChart from './smortChart'
import service from '../../../../request'
import moment from 'moment'

const ThresholdChart = (props) => {
  const { t, i18n } = useTranslation();
  const { Title } = Typography;
  const [charData, setCharData] = useState({ labels: [], datasets: [] })

  const getTypeNameLanguage = (element) => {
    var result = '';
    switch (i18n.language) {
      case 'zhCN':
        result = element.thresholdTypeNameCn || element.thresholdTypeName
        break;
      case 'jaJP':
        result = element.thresholdTypeNameJp || element.thresholdTypeName
        break;
      case 'enUS':
        result = element.thresholdTypeNameEn || element.thresholdTypeName
        break;
      default:
        result = element.thresholdTypeName
        break;
    }
    return result;
  }
  const options = {
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    stacked: false,
    plugins: {
      legend: {
        display: false,
        // labels: {
        //   boxHeight: 10,
        //   boxWidth: 10,
        // },
        // position: 'bottom',
      },
      title: {
        display: false,
        text: 'Chart.js Line Chart - Cubic interpolation mode'
      },
      annotation: {
        annotations: {
          line1: {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y',
            value: props.thresholdSel.threshold,
            borderColor: 'rgb(255 77 79 / 100%)',
            borderWidth: 0.5,
            label: {
              display: true,
              padding: '2',
              content: t('All.Parameter.threshold') + ' ' + getTypeNameLanguage(props.thresholdSel) + ' ' + props.thresholdSel.math + ' ' + props.thresholdSel.threshold + props.thresholdSel.unit,
              enabled: true,
              position: 'top',
              backgroundColor: 'rgb(255 255 255 / 85%)',
              color: 'rgb(255 77 79 / 100%)',
              letterspacing: '3'
            }
          }
        }
      }
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'hour',
          tooltipFormat: 'HH:mm',
          displayFormats: {
            hour: 'HH:mm'
          }
        }
      },
      y: {
        type: 'linear',
        display: true,
        title: {
          display: false,
          text: 'Value'
        },
      }
    }
  }

  const dateSel = useRef(null);
  //切换日期事件
  const pickerOnChange = (date, dateString) => {
    dateSel.current = dateString;
    fetchDetails()
  }

  const disabledDate = (current) => {
    let monentDate = moment()
    // Can not select days before today and today
    var endTime = props.thresholdSel.recoveryTime || null;
    var startTime = props.thresholdSel.thresholdTime;
    if (endTime !== null) {
      return current && (current < moment(startTime).startOf('day') || current > moment(endTime).endOf('day'));
    } else {
      return current && (current < moment(startTime).startOf('day') || current > moment().endOf('day'));
    }
  };

  const dataPara = {
    labels: [],
    datasets: [
      {
        type: 'line',
        label: getTypeNameLanguage(props.thresholdSel),
        data: [],
        borderColor: '#FFCE77',
        stack: 'Stack 1',
        tension: 0.4,
        fill: false,
        yAxisID: 'y',
        pointRadius: '0',
        pointHoverRadius: '0',
        borderWidth: 1.8,
      }
    ],
  };

  //1.根据不同的设备类型获取数据
  //异步调用
  const fetchDetails = () => {
    const userId = cookie.load('userId');
    var url = '';
    switch (props.thresholdSel.deviceTypeId) {
      case 1:
        url = '/pcs/getPcsDetails'
        break;
      case 2:
        url = '/dcdc/getDcdcDetails'
        break;
      case 3:
        url = '/rack/getRackDetails'
        break;

      default:
        break;
    }
    service.get('service-device' + url + '?deviceId=' + props.thresholdSel.deviceId + '&searchDate=' + dateSel.current + '&userId=' + userId).then(res => {
      if (typeof (res) != 'undefined' && res.success) {
        var date = null;
        dataPara.datasets[0].data = [];
        res.data.forEach(data => {
          //数据循环
          date = Date.parse(data['getdatetime']);
          dataPara.labels.push(new Date(date));
          dataPara.datasets[0].data.push(data[props.thresholdSel.databaseField] * 1);

        });
        console.log("dataPara11111111111", dataPara.datasets[0].data)
        setCharData(dataPara)
      }
    });
  }

  useEffect(() => {
    // if (props.thresholdSel.recoveryTime != null) {
    //   dateSel.current = props.thresholdSel.recoveryTime
    // } else {
    //   dateSel.current = moment().format('YYYY-MM-DD');
    // }
    fetchDetails()
  }, [props.thresholdSel])

  useEffect(() => {
    dateSel.current = props.clickDate;
    fetchDetails()
  }, [props.clickDate])

  return (
    <>
      <Space direction='vertical' size={16}>
        <HeaderMenuWrapper>
          <LeftMenuBox>
            <Space direction='vertical' size={0}>
              <Typography.Text strong>
                {props.thresholdSel.deviceName}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{getTypeNameLanguage(props.thresholdSel)}
              </Typography.Text>
              {/* <Typography.Text>
                {getTypeNameLanguage(props.thresholdSel)}
              </Typography.Text> */}
            </Space>
          </LeftMenuBox>
          <RightMenuBox>
            {/* 选择日期 */}
            <DatePicker
              placement='bottomRight'
              allowClear={false}
              picker={'date'}
              onChange={pickerOnChange}
              value={moment(dateSel.current)}
              disabledDate={disabledDate}
              getPopupContainer={triggerNode => triggerNode.parentNode}
            />
          </RightMenuBox>
        </HeaderMenuWrapper>
        <ContentWrapper>
          <SmortChart data={charData} options={options} />
        </ContentWrapper>
      </Space>
    </>
  )
};

export default ThresholdChart;